import MainLayout from "@/layouts/MainLayout.vue";
import UserSpaces from "@/views/Main/UserSpaces.vue";

import LicencePrivate from "@/views/Main/LicencePrivat.vue";

const baseDataRoutes = [
  {
    path: "/",
    name: "main",
    component: MainLayout,
    // params: { nodeId: "locations" },
    children: [
      {
        path: "",
        name: "user-spaces",
        component: UserSpaces
      },
      {
        path: "licence/private",
        name: "licence-private",
        component: LicencePrivate
      }
    ]
  }
];
export default baseDataRoutes;
